import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const DetailsModal = ({ accountNumber, personNames, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [detailsData, setDetailsData] = useState([]);
    const [summaryData, setSummaryData] = useState(null);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (accountNumber) {
            loadDetailsData();
            loadSummaryData();
        }
    }, [accountNumber]);

    const loadDetailsData = async () => {
        setLoading(true);
        setMessage('');
        try {
            const response = await api.getDetailsByAccount(accountNumber);
            const data = response.data || [];
            setDetailsData(data);
        } catch (error) {
            console.error('Ошибка загрузки детализации:', error);
            setMessage('Ошибка загрузки детализации');
        } finally {
            setLoading(false);
        }
    };

    const loadSummaryData = async () => {
        try {
            const response = await api.getDetailsSummaryByAccount(accountNumber);
            const data = response.data ?? response;
            console.log('summaryData set to:', data);
            setSummaryData(data);
        } catch (error) {
            console.error('Ошибка загрузки сводки по детализации:', error);
        }
    };

    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === '') {
            return '-';
        }
        return new Intl.NumberFormat('ru-RU', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(Number(value));
    };

    const formatDateToRussian = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '-';

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    // Получаем долг "По приказам" из сводки (TotalDebt)
    const debtByOrders = summaryData?.totalDebt ?? 0;

    // Получаем остаток из сводки (Balance)
    const balance = summaryData?.balance ?? 0;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content-large" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Детализация по лицевому счету № {accountNumber}</h3>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>

                <div className="modal-tabs">
                    <div className="tabs-header">
                        <button className="tab-button active">
                            Общая информация
                        </button>
                    </div>

                    <div className="tab-content">
                        <div className="info-tab">
                            {message && (
                                <div className={`message ${message.includes('Ошибка') ? 'error' : 'success'}`}>
                                    {message}
                                </div>
                            )}

                            {/* Общая информация */}
                            <div className="details-summary"  style={{ marginTop: '1px' }}>
                                <div className="summary-section"  style={{ marginTop: '1px' }}>
                                    <h4>Информация о счете</h4>
                                    <div className="summary-item">
                                        <label>Лицевой счёт:</label>
                                        <span className="summary-value">{accountNumber}</span>
                                    </div>
                                    <div className="summary-item">
                                        <label>ФИО:</label>
                                        <div className="summary-value">
                                            {personNames && personNames.length > 0 ? (
                                                personNames.map((name, index) => (
                                                    <div key={index}>{name}</div>
                                                ))
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="summary-section">
                                    <h4>Долг</h4>
                                    <div className="summary-item">
                                        <label>По приказам:</label>
                                        <span className="summary-value debt-value">{formatCurrency(debtByOrders)}</span>
                                    </div>
                                    <div className="summary-item">
                                        <label>Остаток:</label>
                                        <span className="summary-value balance-value">{formatCurrency(balance)}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Таблица детализации */}
                            <div className="details-table-section" style={{ marginTop: '15px' }}>
                                <h4 style={{ marginBottom: '10px' }}>Детализация операций</h4>
                                {loading ? (
                                    <div className="loading">Загрузка детализации...</div>
                                ) : detailsData.length === 0 ? (
                                    <div className="no-data">Нет данных по детализации</div>
                                ) : (
                                     <div className="table-wrapper" style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'auto' }}>
                                         <table className="statements-table">
                                             <thead>
                                                 <tr>
                                                     <th rowSpan="2" style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>
                                                         Дата
                                                     </th>
                                                     <th rowSpan="2" style={{ textAlign: 'center', verticalAlign: 'middle', width: '80px' }}>
                                                         Номер
                                                     </th>
                                                     <th rowSpan="2" style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>
                                                         Кредит
                                                     </th>
                                                     <th rowSpan="2" style={{ textAlign: 'center', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                                                         Номер приказа
                                                     </th>
                                                     <th colSpan="4" style={{ textAlign: 'center', borderBottom: '1px solid #dee2e6', borderLeft: '2px solid #6c757d' }}>
                                                         До операции по приказу
                                                     </th>
                                                     <th colSpan="3" style={{ textAlign: 'center', borderBottom: '1px solid #dee2e6', borderLeft: '2px solid #6c757d' }}>
                                                         Расписано
                                                     </th>
                                                     <th colSpan="4" style={{ textAlign: 'center', borderBottom: '1px solid #dee2e6', borderLeft: '2px solid #6c757d' }}>
                                                         После операции по приказу
                                                     </th>
                                                     <th colSpan="4" style={{ textAlign: 'center', borderBottom: '1px solid #dee2e6', borderLeft: '2px solid #6c757d' }}>
                                                         Остаток по счёту
                                                     </th>
                                                 </tr>
                                                 <tr>
                                                     <th style={{ textAlign: 'right', whiteSpace: 'nowrap', borderLeft: '2px solid #6c757d' }}>Основной</th>
                                                     <th style={{ textAlign: 'right' }}>Пени</th>
                                                     <th style={{ textAlign: 'right' }}>Пошлина</th>
                                                     <th style={{ textAlign: 'right' }}>Итого</th>
                                                     <th style={{ textAlign: 'right', whiteSpace: 'nowrap', borderLeft: '2px solid #6c757d' }}>Основной</th>
                                                     <th style={{ textAlign: 'right' }}>Пени</th>
                                                     <th style={{ textAlign: 'right' }}>Пошлина</th>
                                                     <th style={{ textAlign: 'right', whiteSpace: 'nowrap', borderLeft: '2px solid #6c757d' }}>Основной</th>
                                                     <th style={{ textAlign: 'right' }}>Пени</th>
                                                     <th style={{ textAlign: 'right' }}>Пошлина</th>
                                                     <th style={{ textAlign: 'right' }}>Итого</th>
                                                     <th style={{ textAlign: 'right', whiteSpace: 'nowrap', borderLeft: '2px solid #6c757d' }}>Основной</th>
                                                     <th style={{ textAlign: 'right' }}>Пени</th>
                                                     <th style={{ textAlign: 'right' }}>Пошлина</th>
                                                     <th style={{ textAlign: 'right' }}>Итого</th>
                                                 </tr>
                                             </thead>
                                             <tbody>
                                                 {detailsData.map((item, index) => (
                                                     <tr key={index}>
                                                         <td style={{ textAlign: 'center' }}>{formatDateToRussian(item.date)}</td>
                                                         <td style={{ textAlign: 'center' }}>{item.number || '-'}</td>
                                                         <td className="number-cell">{formatCurrency(item.credit)}</td>
                                                         <td style={{ textAlign: 'center' }}>{item.caseNumber || '-'}</td>
                                                         <td className="number-cell" style={{ borderLeft: '2px solid #6c757d' }}>{formatCurrency(item.feeBefore)}</td>
                                                         <td className="number-cell">{formatCurrency(item.penaltyBefore)}</td>
                                                         <td className="number-cell">{formatCurrency(item.tollBefore)}</td>
                                                         <td className="number-cell">{formatCurrency(item.totalBefore)}</td>
                                                         <td className="number-cell" style={{ borderLeft: '2px solid #6c757d' }}>{formatCurrency(item.feeDivided)}</td>
                                                         <td className="number-cell">{formatCurrency(item.penaltyDivided)}</td>
                                                         <td className="number-cell">{formatCurrency(item.tollDivided)}</td>
                                                         <td className="number-cell" style={{ borderLeft: '2px solid #6c757d' }}>{formatCurrency(item.feeAfter)}</td>
                                                         <td className="number-cell">{formatCurrency(item.penaltyAfter)}</td>
                                                         <td className="number-cell">{formatCurrency(item.tollAfter)}</td>
                                                         <td className="number-cell">{formatCurrency(item.totalAfter)}</td>
                                                         <td className="number-cell" style={{ borderLeft: '2px solid #6c757d' }}>{formatCurrency(item.feeBalance)}</td>
                                                         <td className="number-cell">{formatCurrency(item.penaltyBalance)}</td>
                                                         <td className="number-cell">{formatCurrency(item.tollBalance)}</td>
                                                         <td className="number-cell">{formatCurrency(item.totalBalance)}</td>
                                                     </tr>
                                                 ))}
                                             </tbody>
                                         </table>
                                     </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailsModal;
